import i18nFactory from '@yandex-int/i18n';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { ValidationErrorType, ValidationResult } from '../../typings/common';
import { CurrencyCode } from '../../typings/graphql-grid';
import { WalletSwitchOffLimitEditPopupValue } from '../../typings/walletState';
import { formatNumber, parseNumber } from '../FormatHelpers/FormatHelpers';

import * as keyset from './WalletSwitchOffLimitPopupHelpers.i18n';

const i18n = i18nFactory(keyset);

export function validateSwitchOffLimitPopupValue(
    value: WalletSwitchOffLimitEditPopupValue,
    sumLimits: {
        min: number;
        max: number;
    },
    currency: CurrencyCode
): ValidationResult {
    const { paymentMethodId, payerId, sum } = value;

    const errors = [];

    if (paymentMethodId === undefined) {
        errors.push({
            text: i18n('emptyPaymentMethod'),
            type: ValidationErrorType.empty,
            path: 'paymentMethodId'
        });
    }

    if (payerId === undefined) {
        errors.push({
            text: i18n('emptyPayer'),
            type: ValidationErrorType.empty,
            path: 'payerId'
        });
    }

    if (sum === undefined) {
        errors.push({
            text: i18n('emptySum'),
            type: ValidationErrorType.empty,
            path: 'sum'
        });
    } else {
        const parsedSum = parseNumber(sum);

        if (isNaN(parsedSum)) {
            errors.push({
                text: i18n('nanSum'),
                type: ValidationErrorType.nan,
                path: 'sum'
            });
        } else {
            if (parsedSum > sumLimits.max) {
                errors.push({
                    text: i18n('gteMessage', {
                        maxValue: formatNumber(sumLimits.max, 2),
                        currency: mapStringToCurrencySymbol(currency)
                    }),
                    type: ValidationErrorType.lte,
                    path: 'sum'
                });
            }

            if (parsedSum < sumLimits.min) {
                errors.push({
                    text: i18n('lteMessage', {
                        minValue: formatNumber(sumLimits.min, 2),
                        currency: mapStringToCurrencySymbol(currency)
                    }),
                    type: ValidationErrorType.gte,
                    path: 'sum'
                });
            }
        }
    }

    return errors.length
        ? {
              valid: false,
              errors
          }
        : {
              valid: true
          };
}
